type SafeHtmlOptions = {
    readonly allowImages?: boolean;
};

// Preserve basic stored-message formatting without executing sender-provided markup.
export const safeHtml = (value: string, options: SafeHtmlOptions = {}) => {
    const template = document.createElement(`template`);
    template.innerHTML = value || ``;
    template.content.querySelectorAll(`script, style, template, iframe, object, embed, svg, math, form`)
        .forEach(element => element.remove());
    const allowed = new Set([`P`, `BR`, `DIV`, `SPAN`, `B`, `STRONG`, `I`, `EM`, `U`, `S`, `UL`, `OL`, `LI`,
        `BLOCKQUOTE`, `H1`, `H2`, `H3`, `H4`, `H5`, `H6`, `TABLE`, `TBODY`, `THEAD`, `TR`, `TD`, `TH`, `A`, `HR`]);
    if (options.allowImages) allowed.add(`IMG`);
    template.content.querySelectorAll(`*`).forEach(element => {
        if (!allowed.has(element.tagName)) { element.replaceWith(...element.childNodes); return; }
        const href = element.tagName === `A` ? element.getAttribute(`href`) : null;
        const src = element.tagName === `IMG` ? element.getAttribute(`src`) : null;
        const alt = element.tagName === `IMG` ? element.getAttribute(`alt`) || `` : null;
        for (const attribute of Array.from(element.attributes)) element.removeAttribute(attribute.name);
        const source = href ?? src;
        if (source) {
            const unsafeCharacters = /[\u0000-\u001f\\]/.test(source) || source.startsWith(`//`);
            try {
                const url = unsafeCharacters ? null : new URL(source, location.href);
                const allowedProtocols = element.tagName === `IMG` ? [`http:`, `https:`] :
                    [`http:`, `https:`, `mailto:`];
                if (url && allowedProtocols.includes(url.protocol)) {
                    if (element.tagName === `A`) element.setAttribute(`href`, url.href);
                    else {
                        element.setAttribute(`src`, url.href);
                        element.setAttribute(`alt`, alt || ``);
                        element.className = `img-fluid`;
                    }
                } else if (element.tagName === `IMG`) {
                    element.remove();
                }
            } catch {
                if (element.tagName === `IMG`) element.remove();
                // Invalid links remain ordinary text.
            }
        } else if (element.tagName === `IMG`) {
            element.remove();
        }
    });
    return template.innerHTML;
};
